import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
  const location = useLocation();

  return (
    <nav className="bg-bluestar-700 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold">
              BLUE STAR LAUNCH
            </Link>
            <span className="ml-3 text-sm text-bluestar-200">Invoice Maker</span>
          </div>
          <div className="flex items-center space-x-4">
            <Link
              to="/"
              className={`px-3 py-2 rounded-md text-sm font-medium ${
                location.pathname === '/'
                  ? 'bg-bluestar-900 text-white'
                  : 'text-bluestar-100 hover:bg-bluestar-600'
              }`}
            >
              New Invoice
            </Link>
            <Link
              to="/history"
              className={`px-3 py-2 rounded-md text-sm font-medium ${
                location.pathname === '/history'
                  ? 'bg-bluestar-900 text-white'
                  : 'text-bluestar-100 hover:bg-bluestar-600'
              }`}
            >
              View History
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;

